<script setup lang="ts">

window.addEventListener('message', (event) => {
  if (event.origin === 'https://www.tuev-risk-navigator.ai') {
    const token = localStorage.getItem('token');
    event.source.postMessage({ token: token }, event.origin);
  }
});

/**
 * fix for weird primvue bug that adds padding because of the scrollbar on big screens
 * should be removed and handled properly (css) in the future
 */
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "style") {
      const body = document.body;
      const currentStyle = body.getAttribute("style");

      if (currentStyle?.includes("--p-scrollbar-width:")) {
        const newStyle = currentStyle.replace(/--p-scrollbar-width:\s*\d+px;?/g, "").trim();
        body.setAttribute("style", newStyle);
      }
    }
  });
});

observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });

window.addEventListener("load", () => {
  const body = document.body;
  const currentStyle = body.getAttribute("style");

  if (currentStyle?.includes("--p-scrollbar-width:")) {
    const newStyle = currentStyle.replace(/--p-scrollbar-width:\s*\d+px;?/g, "").trim();
    body.setAttribute("style", newStyle);
  }
});
/* end of fix */
</script>

<template>
  <div>
    <div>
      <main>
        <Suspense>
          <RouterView />
        </Suspense>
        <Toast :autoZIndex="true" />
        <ConfirmPopup />
      </main>    
    </div>
  </div>
</template>

<style>
.p-toast {
  z-index: 100000 !important;
}
</style>